// extracted by mini-css-extract-plugin
export default {"family_text_wrap":"ikeaFamilyPlusText_family_text_wrap__3VOw9","title":"ikeaFamilyPlusText_title__rz3+m"};